import React, { useCallback, useRef, useMemo, useState } from 'react';
import { Select } from 'antd';

import debounce from 'lodash/debounce';
import { MAX_FILTER_OPTIONS } from '@utils/constants';
import styles from './index.less';

const { Option } = Select;

const buildOption = (filterKey, filter) => (
  <Option key={filterKey} value={filterKey} label={filter.name} ruletext={filter.rule_text}>
    {filter.name}
  </Option>
);

const FilterSearch = ({ filters, selectedFilters, onSelect }) => {
  const [searchText, setSearchText] = useState('');

  const container = useRef();
  const getContainer = useCallback(() => {
    const { current } = container;
    return current;
  }, [container]);

  const selectedValues = selectedFilters.map((f) => f.fid || f.name);
  const labelValues = selectedFilters.map((f) => ({ label: f.name, value: f.fid || f.name }));

  // filter options
  const filterOptions = useMemo(() => {
    const options = [];
    const selectedOptions = [];

    const selectedSet = new Set(selectedValues);

    /* tslint:disable-next-line */
    for (let i = 0; i < filters.length; i += 1) {
      const filter = filters[i];
      const filterKey = filter.fid || filter.name;
      // render max 25 matches at a time
      if (
        options.length <= MAX_FILTER_OPTIONS &&
        (searchText === '' ||
          `${filter.name} ${filter.rule_text}`.toLowerCase().includes(searchText)) &&
        filter.enabled
      ) {
        options.push(buildOption(filterKey, filter));
      } else if (selectedSet.has(filterKey)) {
        // selected options are always added to the end
        selectedOptions.push(buildOption(filterKey, filter));
      }
    }

    return options.concat(selectedOptions);
  }, [filters, searchText, selectedValues]);

  // debounce keyup
  const onSearch = useCallback(
    debounce((text) => {
      setSearchText(text.toLowerCase());
    }, 300),
    [setSearchText],
  );

  const handleChange = useCallback(
    (value) => {
      onSelect(value);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onSelect],
  );

  return (
    <div className={styles.filterSearch} ref={container}>
      <Select
        mode="multiple"
        dropdownAlign={{ overflow: { adjustY: 0 } }}
        style={{ width: '100%', zIndex: 80 }}
        placeholder="Search filter"
        optionLabelProp="label"
        value={labelValues}
        onSearch={onSearch}
        onDeselect={handleChange}
        onSelect={handleChange}
        filterOption={false}
        getPopupContainer={getContainer}
        autoFocus
      >
        {filterOptions}
      </Select>
    </div>
  );
};

export default React.memo(FilterSearch);
